import { createContext, useState, useContext } from "react";

export const UserOrdersContext = createContext();

export const UserOrdersProvider = ({ children }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Call this after login to set user orders
  const updateOrders = (ordersList) => {
    setOrders(ordersList || []);
  };

  // Optionally, add fetchOrders(token) here if you want to fetch from backend

  return (
    <UserOrdersContext.Provider value={{ orders, setOrders: updateOrders, loading, setLoading, error, setError }}>
      {children}
    </UserOrdersContext.Provider>
  );
};

export const useUserOrders = () => useContext(UserOrdersContext);
